import { useCallback, useRef, useState } from "react";

const DEFAULT_ROW_ACTIONS_COLUMN_SIZE = 80;
const ROW_ACTIONS_COLUMN_PADDING = 8;

export function useRowActionsColumnWidth(customRowActionColSize?: number) {
  const [measuredSize, setMeasuredSize] = useState<number>(
    DEFAULT_ROW_ACTIONS_COLUMN_SIZE
  );
  const widthsByRowRef = useRef<Map<string, number>>(new Map());

  const measureActionsCell = useCallback(
    (rowId: string, el: HTMLElement | null) => {
      if (!el) return;
      if (customRowActionColSize) return;

      const width = Math.ceil(el.scrollWidth);
      if (width === 0) return;

      const map = widthsByRowRef.current;
      if (map.get(rowId) !== width) {
        map.set(rowId, width);
        const target =
          Math.max(...Array.from(map.values())) + ROW_ACTIONS_COLUMN_PADDING;
        setMeasuredSize((prev) => (prev === target ? prev : target));
      }
    },
    [customRowActionColSize]
  );

  const resetMeasurements = useCallback(() => {
    widthsByRowRef.current.clear();
  }, []);

  return {
    rowActionsColumnSize: customRowActionColSize || measuredSize,
    measureActionsCell,
    resetMeasurements,
  };
}
